import { Link } from 'react-router-dom';
import { siteStats } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20urban%20nightscape%20with%20neon%20pink%20and%20red%20light%20streaks%2C%20blurred%20city%20lights%2C%20mysterious%20underground%20vibe%2C%20noir%20atmosphere%2C%20gritty%20texture%2C%20dark%20alley%20aesthetic%20with%20subtle%20glowing%20elements%2C%20cinematic%20widescreen%20composition&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="黑料视频 - 全网最狠吃瓜基地"
          className="w-full h-full object-cover object-top animate-slow-zoom"
          title="黑料视频 - 每日黑料合集实时追踪"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background-50" />
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 py-32 md:py-0">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12 lg:gap-20">
          {/* Left content */}
          <div className="flex-1 w-full animate-fade-slide-in">
            {/* Social proof */}
            <div className="flex items-center gap-3 mb-8">
              <div className="flex -space-x-3">
                <div className="w-10 h-10 rounded-full border-2 border-background-50/80 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20anonymous%20portrait%20silhouette%2C%20mysterious%20person%2C%20low%20key%20lighting%2C%20noir%20style%20headshot%2C%20dramatic%20shadow&width=80&height=80&seq=hero-avatar-01&orientation=squarish"
                    alt="在线瓜友"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 rounded-full border-2 border-background-50/80 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20portrait%20with%20half%20face%20in%20shadow%2C%20anonymous%20person%2C%20low%20key%20lighting%2C%20noir%20photography%2C%20dramatic%20contrast&width=80&height=80&seq=hero-avatar-02&orientation=squarish"
                    alt="在线瓜友"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 rounded-full border-2 border-background-50/80 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20silhouette%20portrait%20of%20anonymous%20figure%2C%20profile%20view%2C%20mysterious%20person%2C%20low%20key%20noir%20headshot%2C%20deep%20shadows&width=80&height=80&seq=hero-avatar-03&orientation=squarish"
                    alt="在线瓜友"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-sm text-foreground-300 font-medium">
                <strong className="text-primary-400">{siteStats.onlineUsers}</strong> 瓜友实时在线
              </span>
            </div>

            {/* Main headline */}
            <h1 className="text-[clamp(2.5rem,6vw,5.5rem)] font-black leading-[1.05] tracking-[-0.03em] mb-8">
              <span className="block text-foreground-50">全网最狠</span>
              <span className="block text-primary-500">吃瓜基地</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-400 max-w-xl leading-relaxed mb-10">
              每日整理明星八卦、网红黑料、暴走视频合集。
              拒绝官腔，只爆猛料，凌晨更新传送门不迷路。
            </p>

            {/* CTA Button */}
            <a
              href="#video-grid"
              className="inline-flex items-center gap-3 group cursor-pointer"
            >
              <span className="px-6 py-3 bg-foreground-50 text-background-950 text-sm font-bold rounded-full whitespace-nowrap transition-all duration-300 hover:bg-primary-500">
                立即吃瓜
              </span>
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-950 group-hover:translate-x-1 transition-transform duration-300">
                <i className="ri-arrow-right-line text-xl"></i>
              </span>
            </a>
          </div>

          {/* Right - Stats */}
          <div className="lg:w-[380px] flex-shrink-0 animate-fade-in-delayed">
            <div className="grid grid-cols-2 gap-4">
              <StatCard
                icon="ri-vidicon-line"
                value={siteStats.totalVideos}
                label="视频总量"
              />
              <StatCard
                icon="ri-flashlight-line"
                value={siteStats.dailyUpdate}
                label="每日更新"
              />
              <StatCard
                icon="ri-user-smile-line"
                value={siteStats.onlineUsers}
                label="在线瓜友"
              />
              <StatCard
                icon="ri-chat-3-line"
                value={siteStats.totalComments}
                label="评论总数"
              />
            </div>

            {/* Live indicator */}
            <div className="mt-8 p-4 rounded-xl bg-background-100/80 backdrop-blur-sm border border-background-200/60">
              <div className="flex items-center gap-3">
                <span className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-500 opacity-75" />
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-accent-500" />
                </span>
                <span className="text-sm text-foreground-300 font-medium">
                  凌晨 <strong className="text-foreground-100">00:00</strong> 准时更新
                </span>
              </div>
              <p className="text-xs text-foreground-600 mt-2 pl-6">
                今日已更新 <span className="text-accent-400 font-semibold">18</span> 条猛料
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function StatCard({ icon, value, label }: { icon: string; value: string; label: string }) {
  return (
    <div className="p-4 rounded-xl bg-background-100/70 backdrop-blur-sm border border-background-200/60 hover:border-primary-500/30 transition-all duration-300">
      <div className="w-8 h-8 flex items-center justify-center mb-2">
        <i className={`${icon} text-primary-500 text-xl`}></i>
      </div>
      <div className="text-2xl font-black text-foreground-50 tracking-tight">{value}</div>
      <div className="text-xs text-foreground-600 mt-1">{label}</div>
    </div>
  );
}